interface V3IconPDFProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconPDF = ({ stroke = "#ABB0BA" }: V3IconPDFProps) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 1v4a1 1 0 0 0 1 1h4" stroke={stroke} strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M11.571 15H4.43c-.38 0-.743-.164-1.01-.456a1.628 1.628 0 0 1-.419-1.1V2.556c0-.413.15-.809.418-1.1A1.372 1.372 0 0 1 4.428 1H9l4 4v8.444c0 .413-.15.809-.418 1.1a1.372 1.372 0 0 1-1.01.456Z" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>